export const FETCH_TOKENS_SUCCESS = 'fetchTokensSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_TOKENS_M = 'updateActiveSortFieldTokensMutation';
export const UPDATE_SEARCH_TOKENS_M = 'updateSearchTokensMutation';
export const CLEAR_SEARCH_TOKENS_M = 'clearSearchTokensMutation';
